import React from 'react';
import MediaHelper from "../../../helpers/MediaHelper";
import ProductFormError from "../errors/ProductFormError";
import Module from "../../../models/module/Module";
import StandardTextFormEditorComponent from "../../basics/form/StandardTextFormEditorComponent";
import MediaImageUploadComponent from "../../media/image/MediaImageUploadComponent";
import MediaFileUploadComponent from "../../media/image/MediaFileUploadComponent";
import { PriceHelper } from "../../../helpers";

class ProductTextFormComponent {
    static fields(state) {
        let fields = [
            {
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.title",
                        type: "text",
                        name: 'title',
                        customFeedback: ProductFormError,
                        formErrorName: "title"
                    }
                ]
            }
        ];

        if (state.settings.use_spotlight) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.spotlight",
                        type: "switch",
                        name: 'spotlight',
                        customFeedback: ProductFormError,
                        formErrorName: "spotlight"
                    }
                ]
            });
        }

        if (state.settings.use_categories) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: 'CMS.Product.Content.Form.category',
                        type: "select",
                        name: "category",
                        options: state.settings.references.map(item => {
                            if (item.children.length) return false;
                            let label = item.depthLabel.join(' > ');
                            return { value: item.id, label: label };
                        }).filter(x => x !== false),
                        customFeedback: ProductFormError,
                        formErrorName: "category"
                    }
                ]
            });
        }

        if (state.settings.show_article_number) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.article_number",
                        type: "text",
                        name: 'article_number',
                        customFeedback: ProductFormError,
                        formErrorName: "article_number"
                    }
                ]
            });
        }

        if (state.settings.use_webshop) {

            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.unit_price",
                        type: "text",
                        name: 'unit_price',
                        customFeedback: ProductFormError,
                        formErrorName: "unit_price",
                        customProps: {
                            prepend: {
                                name: 'currency',
                                disabled: true,
                                options: Object.keys(PriceHelper.getCurrencyList()).map(currency => (
                                    <option value={currency} key={currency} dangerouslySetInnerHTML={{ __html: PriceHelper.getCurrencySign(currency) }} />
                                ))
                            }
                        }
                    }
                ]
            });
        }

        if (state.settings.show_stock) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.stock",
                        type: "number",
                        name: 'stock',
                        customFeedback: ProductFormError,
                        customProps: { min: 0 },
                        formErrorName: "stock"
                    }
                ]
            });
        }

        if (state.settings.use_product_tags) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.tags",
                        type: 'select-creatable', //"tags",
                        name: 'tags',
                        options: state.settings.tags ? state.settings.tags.map(tag => {
                            return { value: tag, label: tag };
                        }) : [],
                        multi: true,
                        clearable: true,
                        optional: true,
                        customFeedback: ProductFormError,
                        formErrorName: "tags"
                    }
                ]
            });
        }

        if (state.settings.show_summary) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Product.Content.Form.summary",
                        type: "textarea",
                        name: 'summary',
                        customFeedback: ProductFormError,
                        formErrorName: "summary"
                    }
                ]
            });
        }

        // fields = Module.renderAdditionalFields(state.module, fields);
        fields = Module.renderAdditionalFields(state, fields);

        fields.push({
            type: "col",
            md: 12,
            fields: [],
            custom: StandardTextFormEditorComponent,
            customProps: { valueField: 'content', label: 'CMS.Product.Content.Form.content', placeholder: 'CMS.Product.Content.Form.content.placeholder' }
        });

        if (state.settings.show_cover_image) {
            fields.push({
                type: "col",
                md: 12,
                fields: [],
                custom: MediaImageUploadComponent,
                customProps: { label: 'CMS.Product.Content.Form.image', type: 'product_image', settings: state.settings, field: 'image', formErrorName: 'image' }
            });
        }

        if (state.settings.need_header_img) {
            fields.push({
                type: "col",
                md: 12,
                fields: [],
                custom: MediaImageUploadComponent,
                customProps: { label: 'CMS.Product.Content.Form.header_image', type: 'product_header_image', dimensionPrefix: 'header_img', settings: state.settings, field: 'header_image', formErrorName: 'header_image' }
            });
        }

        if (state.settings.show_pdf) {
            fields.push({
                type: "col",
                md: 12,
                fields: [],
                optional: true,
                custom: MediaFileUploadComponent,
                customProps: { label: 'CMS.Product.Content.Form.pdf_document', type: 'product_file', settings: state.settings, field: 'pdf_document', formErrorName: 'pdf_document' }
            });
        }

        return [{
            type: "row",
            children: fields
        }];
    }

    static async fields_image_before_submit(element) {
        return new Promise(async (resolve, reject) => {
            let module = Module.get();
            let item = element.state.model;

            let type = module ? module.module.type : null;

            if (item.image !== null && item.image !== undefined && (typeof item.image !== 'string')) {
                item.image = await MediaHelper.uploadImage(item, 'image', 'product_image', type, element.props.id, null, item.title);
            }

            if (item.header_image !== null && item.header_image !== undefined && (typeof item.header_image !== 'string')) {
                item.header_image = await MediaHelper.uploadImage(item, 'header_image', 'product_header_image', type, element.props.id, null, item.title);
            }

            if (item.pdf_document !== null && item.pdf_document !== undefined && (typeof item.pdf_document !== 'string')) {
                item.pdf_document = await MediaHelper.uploadImage(item, 'pdf_document', 'product_file', type, element.props.id, null, item.title);
            }

            element.setState({ model: item }, () => resolve(true))
        })
    }
}

export default ProductTextFormComponent;